export const getLocalizationFormat = (subst: string): string => {
  return `%{${subst}}`;
};

export const hasLocalesToFetch = (localizationKeys: string[] | null | undefined): boolean => {
  if (!localizationKeys || localizationKeys?.length === 0) {
    console.error("fetchLocales cannot be called with empty localization keys");
    return false;
  }
  return true;
};
